import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
// import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import * as firebase from 'firebase/app';

@Injectable()
export class UserService {

  constructor(
   public db: AngularFireDatabase,
   public afAuth: AngularFireAuth
  ) { }


  getCurrentUser() {
    return new Promise<any>((resolve, reject) => {
      const user = firebase.auth().onAuthStateChanged(data => {
        if (data) {
          const sub = this.getMoreInfo(data.uid).subscribe(userData => {
            sub.unsubscribe();
            resolve(userData);
          });
        } else {
          reject('No user logged in');
        }
      });
    });
  }

  updateCurrentUser(value) {
    return new Promise<any>((resolve, reject) => {
      const user = firebase.auth().currentUser;
      user.updateProfile({
        displayName: value.name,
        photoURL: user.photoURL
      }).then(res => {
        resolve(res);
      }, err => reject(err));
    });
  }

  getMoreInfo(uuid) {
    const items = this.db.object(`users/${uuid}`).valueChanges();
    return items;
  }

  register(user, value) {
    value.type = 'user';
    value.uuId = user.uid;
    delete value.password;
    delete value['password-verify'];

    this.db.object(`/users/${user.uid}`).update(value);
  }

  resetPassword(email: string) {
    const auth = firebase.auth();
    return auth.sendPasswordResetEmail(email);
  }
}
